import FeatureService from "../classes/feature-service";
import _ from "lodash";

export default {
  async install(Vue) {
    const defaults = jsConfig.features.defaults;

    Vue.prototype.$featureFlags = Vue.observable(_.cloneDeep(defaults));
    Vue.FeatureService = new FeatureService(defaults);

    const featuresSdkKey = jsConfig.features.sdkKey;

    if (featuresSdkKey) {
      Vue.FeatureService.init(
          featuresSdkKey,
          jsConfig.features.userKey,
          jsConfig.features.mockedFeatures || {}
      );
      Vue.FeatureService.onUpdate((updates) => {
        for (const flag in updates) {
          Vue.set(Vue.prototype.$featureFlags, flag, updates[flag]);
        }
      });
    }

    Vue.prototype.$trackEvent = (eventName) => {
      Vue.FeatureService.trackEvent(eventName);
    };
  }
}
